import { createAction, props } from "@ngrx/store";

export const setPageFullscreen = createAction("[Page] Set Page Fullscreen", props<{pageFullscreen: boolean }>());
